module.exports = __webpack_public_path__ + "static/media/r25.3a483062.jpg";